import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { SortLabel as SortLabelStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

type Props = PropsWithChildren<{
  /** If `true`, the label will have a different styling */
  active?: boolean
  /** Sets the side of the arrow icon. */
  align?: 'left' | 'right'
  /** The current sort direction */
  direction?: 'asc' | 'desc' | false
  /** sort index for multiple column sorting */
  index?: number
}>

export type TableSortLabelProps = Props & CommonProps

const useStyles = createUseStyles(SortLabelStyles, 'tablesortlabel')

export const TableSortLabel = ({
  active = false,
  direction = 'desc',
  align,
  index = 0,
  className,
  children,
  ...rest
}: TableSortLabelProps) => {
  const classes = useStyles()
  return (
    <div
      role='button'
      className={clsx(
        className,
        classes.root,
        active && classes._active,
        direction === 'asc' && classes._asc,
        align === 'right' && classes._right,
      )}
      {...rest}
    >
      {children}
      <div className={classes.arrow}>{index > 0 && <span className={classes.index}>{index}</span>}</div>
    </div>
  )
}

export default TableSortLabel
